import { render, staticRenderFns } from "./Gezeiten.vue?vue&type=template&id=187d3a90&"
import script from "./Gezeiten.vue?vue&type=script&lang=js&"
export * from "./Gezeiten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports